module.exports = __webpack_public_path__ + "static/rocket2-81f2f507e9fa8ae60b801c533d81d4ac.png";